import { IconClose } from '@hulu-react-style-components/icons';
import React from 'react';
import { CloseButtonProps } from 'react-toastify';

import { AlertCloseButtonStyled, ToastContainerStyled } from './styled';

const CloseButton = ({ closeToast }: CloseButtonProps): JSX.Element => (
  <AlertCloseButtonStyled
    ariaLabel="close alert"
    onClick={(e): void => {
      e.preventDefault();
      closeToast(e);
    }}
  >
    <IconClose data-testid="buttonAlertClose" />
  </AlertCloseButtonStyled>
);

const AdmanToastContainer = (): JSX.Element => (
  <ToastContainerStyled icon={false} position="top-right" closeButton={CloseButton} hideProgressBar />
);

export default AdmanToastContainer;
